<div class="main-menu legacy">
  <div class="main-menu__home">
    <div class="main-menu__icon-container">
      <a [routerLink]="'/home'">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="primus-logo"
          fill="none"
          viewBox="0 0 73 16"
          height="1rem"
        >
          <path fill="currentColor"
            d="M12.8556 1.14594C11.932.379915 10.5822 0 8.80927 0H4.139v15.7992h3.10116V2.539h1.40849c.84633 0 1.46715.17298 1.86565.51892.3954.34594.5961.8834.5961 1.60927 0 .71969-.2378 1.2664-.7104 1.64324-.42624.33978-1.05018.5251-1.86871.55907v2.72742c1.72351-.09885 4.65171-.65175 5.42391-3.17839.0155-.04942.0278-.09576.0433-.14516.0216-.07104.0401-.13901.0587-.20387.0988-.37375.1544-.77838.1729-1.21081.0031-.10192.0124-.20077.0124-.30579-.0031-1.50733-.4634-2.64403-1.3869-3.40696ZM28.1544.009254h-2.8293V2.83861h2.8293V.009254ZM20.2255 4.97914c-.59.383-1.0595.88958-1.4054 1.5166h-.1514l-.4509-1.88108h-2.3105V15.8023h3.0518v-5.6958c0-.8988.2718-1.60304.8154-2.10034.5437-.5004 1.3035-.75058 2.2765-.75058.3521 0 .6548.03398.9019.09885l.2286-2.86024c-.2749-.06176-.6178-.08958-1.0317-.08958-.695 0-1.3344.19151-1.9243.57453ZM0 9.58763h2.82935V6.75828H0v2.82935Zm25.2108 6.21157h3.0517V4.61467h-3.0517V15.7992Zm46.9127-4.7506c-.1915-.4015-.4942-.7536-.8988-1.06252-.4078-.30578-1.0471-.63629-1.9213-.9915-.9822-.39227-1.6154-.6888-1.9058-.88957-.2903-.20078-.4355-.43552-.4355-.71042 0-.48804.451-.72897 1.3498-.72897.5066 0 1.0039.07722 1.4919.23166.4881.15444 1.0101.34903 1.5722.58996l.9205-2.20232c-1.2757-.58686-2.5854-.88031-3.9321-.88031-1.4146 0-2.505.27182-3.2772.81545-.7691.54363-1.1552 1.31274-1.1552 2.30735 0 .5807.0927 1.06872.2749 1.4641.1853.39845.4788.74748.8803 1.05639.4047.3058 1.0348.6394 1.8965 1.0008.5993.2532 1.0811.4756 1.4394.664.3614.1885.6147.3583.7599.5097.1482.1482.2193.3459.2193.5869 0 .6393-.5529.9606-1.6618.9606-.5405 0-1.1645-.0896-1.8749-.2687-.7104-.1792-1.3498-.4047-1.9181-.6703v2.5204c.5004.2132 1.0378.3738 1.6123.485.5746.1081 1.2664.1637 2.0819.1637 1.5845 0 2.7768-.2996 3.5768-.8988.7969-.5993 1.1954-1.4734 1.1954-2.6224 0-.5529-.0958-1.0317-.2904-1.4302ZM44.6023 4.40463c-.7351 0-1.3931.14208-1.9768.42934-.5838.28726-1.0255.6919-1.3251 1.21081h-.2688c-.593-1.09653-1.7266-1.64015-3.4007-1.64015-.7352 0-1.3838.14517-1.9521.43552-.5684.29035-1.0008.6919-1.3004 1.20772h-.1699l-.4108-1.43011h-2.3321V15.8054h3.0518v-5.2695c0-1.31273.176-2.25792.5312-2.83242.3522-.57453.9205-.8587 1.702-.8587.5807 0 1.0069.20077 1.2756.60541.2688.40154.4047 1.01004.4047 1.81622v6.53279h3.0517v-5.6123c0-1.16142.1853-2.00775.556-2.54212.3707-.53437.9297-.8 1.6772-.8.5807 0 1.007.20077 1.2757.60541.2718.40154.4077 1.01004.4077 1.81622v6.53279h3.061V8.50657c0-1.4332-.3243-2.47722-.9761-3.12587-.6548-.65174-1.6123-.97607-2.8818-.97607Zm13.7544 5.47335c0 1.32202-.1884 2.26722-.5714 2.83552-.3799.5714-.9977.8556-1.8502.8556-.627 0-1.0842-.2008-1.3714-.6054-.2873-.4046-.4294-1.01-.4294-1.8162V4.61466h-3.0517v7.29264c0 1.322.3336 2.3321 1.0008 3.0363.6672.7042 1.6587 1.0564 2.9714 1.0564.766 0 1.4517-.1421 2.051-.4263.6023-.2841 1.0625-.6857 1.3899-1.2046h.1606l.4109 1.4301h2.3413V4.61466h-3.0518v5.26332Z" />
        </svg>
      </a>
    </div>

    <div class="main-menu__vertical-line"></div>

    <div class="main-menu__museum">
      <span title="{{museum.name}}">
        {{museum.shortName}}
      </span>
    </div>

    <div class="main-menu__vertical-line"></div>

    <div
      class="main-menu__version-container text-blue-hover"
      (click)="goToAboutPrimus()"
      (keydown)="null"
    >
      <div title="Client v{{clientVersion}}">
        v{{backendVersion}}
        <div class="circle"></div>
      </div>

      @if (edition) {
        <div>
          {{edition.title | translate}}
        </div>
      }
    </div>
  </div>

  <div class="main-menu__content">
    @if (notifications.length) {
      <div class="main-menu__message-button-container">
        <a
          class="main-menu__message-button"
          (click)="toggleMessage()"
        >
          <i class="icon-bell"></i>

          <div class="main-menu__notify">
            <span class="heartbeat"></span>

            <span class="point"></span>
          </div>
        </a>
      </div>
    }

    <div
      class="main-menu__menu-container dropdownIgnoreClicks"
      [ngClass]="{'showMainMenu': toggleMenuItem}"
    >
      <div class="main-menu__menu">
        <ul>
          <li [ngClass]="{'active': currentStateName === 'home' || !currentStateName}">
            <span class="top-line bg-blue"></span>

            <a
              class="main-menu__menu-button"
              [routerLink]="'/home'"
            >
              <mat-icon>
                home
              </mat-icon>

              <span>
                {{ 'TRANS__MAIN_MENU__HOME_BUTTON' | translate }}
              </span>
            </a>
          </li>

          <li [ngClass]="{'active': currentStateName?.startsWith('home.primus.search')}">
            <span class="top-line bg-blue"></span>

            <a
              class="main-menu__menu-button"
              (click)="homeButton()"
            >
              <mat-icon>
                search
              </mat-icon>

              <span>
                {{ 'TRANS__MAIN_MENU__SEARCH_BUTTON' | translate }}
              </span>
            </a>
          </li>

          @for (operation of operationContainer?.operations; track $index) {
            <!-- Hide FAQ operation button since its moved to a sidebar button -->
            @if (operation.operation_steps[0].change_state[0].state_name !== 'home.primus.faq') {
              <li [ngClass]="{'active': isActive(operation)}">
                <span class="top-line bg-blue"></span>

                <a
                  class="main-menu__menu-button-right"
                  routerLinkActive="active"
                  (click)="selectedItem(operation.operation_steps[0].change_state[0].state_name, operation.operation_steps[0].change_state[0].state_params)"
                  [queryParams]="getQueryParams()"
                  [routerLink]="primusStateMapper.routerLinkFromState(operation.operation_steps[0].change_state[0].state_name)"
                >
                  <mat-icon>
                    {{operation.menu_icon}}
                  </mat-icon>

                  <span>
                    {{ operation.menu_title | translate }}
                  </span>
                </a>
              </li>
            }
            @else if (operation.operation_steps[0].change_state[0].state_name === 'home.primus.faq' && !isWhitelisted){
              <li [ngClass]="{'active': isActive(operation)}">
                <span class="top-line bg-blue"></span>

                <a
                  class="main-menu__menu-button-right"
                  routerLinkActive="active"
                  (click)="selectedItem(operation.operation_steps[0].change_state[0].state_name, operation.operation_steps[0].change_state[0].state_params)"
                  [queryParams]="getQueryParams()"
                  [routerLink]="primusStateMapper.routerLinkFromState(operation.operation_steps[0].change_state[0].state_name)"
                >
                  <mat-icon>{{operation.menu_icon}}</mat-icon>
                  <span>
                    {{ operation.menu_title | translate }}
                  </span>
                </a>
              </li>
            }
          }
        </ul>

        @if (user) {
          <app-main-menu-user
            class="main-menu__user user-mobile-menu"
            [user]="user"
            (click)="toggleJobStatus()"
            (keydown)="null"
          ></app-main-menu-user>
        }
      </div>


      @if (isWhitelisted) {
        <button
          mat-icon-button
          class="main-menu__faq-button"
          (click)="showFaqSidebar()"
          [ngClass]="{'text-blue': showFaq}"
        >
          <mat-icon>help_outline</mat-icon>
        </button>
      }

      @if (openMessage && notifications.length) {
        <app-message-and-notifications
          [notifications]="notifications"
          [currentIndex]="currentIndex"
        ></app-message-and-notifications>
      }
    </div>

    <app-job-statuses
      [closeMenu]="closeJobStatus"
      class="main-menu__job-status"
    ></app-job-statuses>

    @if (user) {
      <app-main-menu-user
        class="main-menu__user hide-on-mobile"
        [user]="user"
        (click)="toggleJobStatus()"
        (keydown)="null"
      ></app-main-menu-user>
    }


    <div
      class="drop-down-menu-button dropdownIgnoreClicks"
      (click)="toggleMenu()"
      (keydown)="null"
    >
      <i class="icon-hamburger"></i>
    </div>
  </div>

  @if (openMessage && notifications.length) {
    <div
      class="overlay"
      (click)="toggleMessage()"
      (keydown)="null"
    ></div>
  }
</div>
